import { ImperfectiveVerb } from '../../types'

const ебаться: ImperfectiveVerb = {
  type: 'imperfective verb',
  infinitive: 'ебаться',
  indicativePastSingularMasculine: 'ебался',
  indicativePastSingularFeminine: 'ебалась',
  indicativePastSingularNeuter: 'ебалось',
  indicativePastPlural: 'ебались',
  indicativePresentSingularFirstPerson: 'ебусь',
  indicativePresentSingularSecondPerson: 'ебёшься',
  indicativePresentSingularThirdPerson: 'ебётся',
  indicativePresentPluralFirstPerson: 'ебёмся',
  indicativePresentPluralSecondPerson: 'ебётесь',
  indicativePresentPluralThirdPerson: 'ебутся',
  imperativeSingularSecondPerson: 'ебись',
  imperativePluralSecondPerson: 'ебитесь',
}

export default ебаться
